/**
 * Per-user tour persistence (v1: localStorage; backend persistence can
 * follow). Records whether a tour was completed or dismissed mid-run plus
 * the last step index so a cancelled tour stays resumable.
 */

export interface TourProgress {
  status: 'completed' | 'dismissed'
  lastStepIndex: number
}

function storageKey(tourId: string, userId: string): string {
  return `maxflow-tour:${tourId}:${userId}`
}

export function readTourProgress(tourId: string, userId: string): TourProgress | null {
  try {
    const raw = localStorage.getItem(storageKey(tourId, userId))
    if (!raw) return null
    const parsed = JSON.parse(raw) as Partial<TourProgress>
    if (parsed.status !== 'completed' && parsed.status !== 'dismissed') return null
    return {
      status: parsed.status,
      lastStepIndex: typeof parsed.lastStepIndex === 'number' ? parsed.lastStepIndex : 0,
    }
  } catch {
    return null
  }
}

export function writeTourProgress(tourId: string, userId: string, progress: TourProgress): void {
  try {
    localStorage.setItem(storageKey(tourId, userId), JSON.stringify(progress))
  } catch {
    // Storage full/blocked — persistence is best-effort, never break the tour.
  }
}
